export default {
    _prefix: "qualityFormEditor.evaluationAssistance",
    operator: {
        EXISTS: "includes",
        NOTEXISTS: "excludes",
    },
    labels: {
        and: "AND",
        select: "select ",
        condition:
            "{{#Prefix}}{{/Prefix}}  if conversation {{#AssistanceConditionOperator}}{{/AssistanceConditionOperator}} these topics {{#TopicSelector}}{{/TopicSelector}}",
        dropDownOptions: "dropdown for conditional operators",
        selectTopics: "Select Topics",
        topics: "Topics",
        addConditions: "Add Evaluation Assistance Condition",
    },
    errors: {
        insufficientTopics: "Each condition must have at least 1 topic in it.",
        tooManyTopics: (maxAssistanceConditionTopics: {
            maxAssistanceConditionTopics: number;
        }) =>
            "Assistance conditions cannot have more than {{maxAssistanceConditionTopics}} topics.",
        topicDeleted:
            "This condition is invalid as one or more Topics have been deleted",
        assistedAnswerOptionInvalid:
            "Evaluation assistance configured on this answer is invalid as one or more Topics have been deleted",
        sameTopicInDifferentConditions:
            "The same topic cannot be selected for more than one different conditions",
    },
};
